import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import type { ReviewWindowRule } from '../../types';

export default function ReviewWindowRulePicker({ value, onChange, allowLegacy = false, disabled = false }: {
  value: ReviewWindowRule | null; onChange: (rule: ReviewWindowRule | null) => void; allowLegacy?: boolean; disabled?: boolean;
}) {
  return <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
    <TextField select size="small" label="Going forward, report" value={value?.kind || ''} disabled={disabled}
      SelectProps={{ native: true }} inputProps={{ 'aria-label': 'Going forward, report' }}
      onChange={(e) => onChange(e.target.value === 'trailing_days' ? { kind: 'trailing_days', days: 7 }
        : e.target.value ? { kind: e.target.value as 'last_complete_week' | 'frozen' } : null)}>
      {allowLegacy && <option value="">No rule — each number rolls its own length</option>}
      <option value="last_complete_week">Last complete week (Mon–Sun)</option>
      <option value="frozen">Stay frozen on the source period</option>
      <option value="trailing_days">Trailing days, ending the last complete day</option>
    </TextField>
    {value?.kind === 'trailing_days' && <TextField size="small" type="number" label="Days" value={value.days} disabled={disabled}
      inputProps={{ min: 1, step: 1, 'aria-label': 'Trailing days' }} sx={{ width: 100 }}
      onChange={(e) => onChange({ kind: 'trailing_days', days: Number(e.target.value) })} />}
  </Box>;
}
